<template>
<div v-if="!isMobile">
    <div v-if="_g_UserFeatures.permissions.dynamic_stockchart">
        <div v-if="_g_ToggleBetweenTableAndChart">
            <div v-if="is_a_search" class="title-searches">
              <span class="search-text">{{search_text}}</span><span class="material-icons-outlined close-searches" @click="_closeSearch()">close</span>
            </div>
            <div class="main-sidebar-left">
                <Finder/>
                <div class="stocks-container">
                    <Stocks />
                </div>            
            </div>
            <div class="mdc-layout-grid__inner sidebar-menu-margin" id="dragable-container">
                <div v-if="_g_SelectedTicker.chart" class="mdc-layout-grid__cell--span-12 stockchart-chart">                    
                    <iframe :src="url_stock" width="98.55%" frameborder="0" id="iframe" style="height: 100%;" :class="{'chart-with-search-tittle': is_a_search}"></iframe>
                    <!--<Chart :symbol= "url_stock"/> Para añadir el grafico de tradingview descomentamos esta linea y comentamos la de arriba-->
                </div>
            </div>
        </div>

        <div v-else>
            <div class="main-sidebar-left">
                <Finder/>
            </div>
            <div class="mdc-layout-grid__inner sidebar-menu-margin-stocks-table" id="dragable-container">
                <div class="mdc-layout-grid__cell--span-12">
                    <StocksTable />
                </div>
            </div>
        </div>
    </div>

    <div v-else>
        <div v-if="_g_ToggleBetweenTableAndChart">
            <div class="main-sidebar-left">
                <Finder />
                <div class="stocks-container">
                    <Stocks />
                </div>            
            </div>
            <div class="mdc-layout-grid__inner sidebar-menu-margin" id="dragable-container">
                <div class="mdc-layout-grid__cell--span-12 stockchart-chart">
                    <div @keyup.enter="_searchStocks()">
                        <InputTextOutline id="searcher-tickers" style="width: 15%; margin-left: 6px; margin-top: 5px;" @_emit_method_order_input="_getValueFromInput" ref="getInputMontanteInferior" :permission="true" :character_counter_permission="false" :icon_permission="true" :helper_permission="true" input_key_to_save_user_values="ticker" input_class_character_counter="ticker-counter" icon_class="input-icon" icon_name="" input_label="" input_helper="" :has_focus="false" :length="32" computed_value="MSFT" :computed_value_permission="true" :test_field_is_numeric="false" />
                    </div>
                    <iframe :src="url_anonymous" width="98.55%" frameborder="0" id="iframe" style="height: 98%;"></iframe>
                    <!--<Chart :symbol= "url_stock"/> Para añadir el grafico de tradingview descomentamos esta linea y comentamos la de arriba-->
                </div>
            </div>
        </div>

        <div v-else>
            <div class="main-sidebar-left">
                <Finder />
            </div>
            <div class="mdc-layout-grid__inner sidebar-menu-margin-stocks-table" id="dragable-container">
                <div class="mdc-layout-grid__cell--span-12">
                    <StocksTable />
                </div>
            </div>
        </div>
    </div>
</div>

<div v-else style="height: 100%;">
  <div v-if="_g_UserFeatures.permissions.dynamic_stockchart" style="height: 100%;">
    <div v-if="!_g_option_mobile" style="height: 100%;">
      <iframe :src="url_stock" width="100%" frameborder="0" id="mobile-iframe" style="height: 100%;"></iframe>
    </div>
    <!--<Chart :symbol= "url_stock"/> Para añadir el grafico de tradingview descomentamos esta linea y comentamos la de arriba-->
  </div>
  <div v-else style="height: 100%;">
    <div class="mdc-layout-grid__cell--span-12 anonymous-stockchart-chart" style="height: 100%; overflow-y: scroll;">
        <div @keyup.enter="_searchStocks()">
          <InputTextOutline id="searcher-tickers" style="width: 15%; margin-left: 6px; margin-top: 5px;" @_emit_method_order_input="_getValueFromInput" ref="getInputMontanteInferior" :permission="true" :character_counter_permission="false" :icon_permission="true" :helper_permission="true" input_key_to_save_user_values="ticker" input_class_character_counter="ticker-counter" icon_class="input-icon" icon_name="" input_label="" input_helper="" :has_focus="false" :length="32" computed_value="MSFT" :computed_value_permission="true" :test_field_is_numeric="false" />
        </div>
        <iframe :src="url_anonymous" width="100%" frameborder="0" id="mobile-iframe" style="height: 100%;"></iframe>
      </div>
    <!--<div class="mdc-layout-grid__inner" id="anonymous-dragable-container">
      <div v-if="_g_SelectedTicker.chart" class="mdc-layout-grid__cell--span-12 anonymous-stockchart-chart">
        <div @keyup.enter="_searchStocks()">
          <InputTextOutline id="searcher-tickers" style="width: 15%; margin-left: 6px; margin-top: 5px;" @_emit_method_order_input="_getValueFromInput" ref="getInputMontanteInferior" :permission="true" :character_counter_permission="false" :icon_permission="true" :helper_permission="true" input_key_to_save_user_values="ticker" input_class_character_counter="ticker-counter" icon_class="input-icon" icon_name="" input_label="" input_helper="" :has_focus="false" :length="32" computed_value="MSFT" :computed_value_permission="true" :test_field_is_numeric="false" />
        </div>
        
      </div>
    </div>-->
  </div>
</div>
</template>


<script>
import Stocks from '@/components/stockchart/components/Stocks.vue'
import Finder from '@/components/stockchart/components/Finder/Finder-Base.vue'
import StocksTable from '@/components/stockchart/components/StocksTable.vue'
import InputTextOutline from "@/components/helpers/InputTextOutline.vue";
import { mapMutations, mapGetters } from "vuex";
import APICaller from "@/components/codeComponents/APICaller.js";
import GetStocks from "@/components/codeComponents/GetStocks.js";

//import Chart from '@/components/TVChartContainer.vue' para importar el tradingview descomentamos esta linea

import { isMobile } from 'mobile-device-detect';
import { isTablet } from 'mobile-device-detect';

export default {
  mixins: [APICaller, GetStocks],
  name: 'Stockchart',
  components: {
    Finder,
    Stocks,
    StocksTable,
    InputTextOutline,
    //Chart, descomentamos tambien esta linea
  },
  data: () => ({
      isMobile: window.innerWidth < 901,
      symbol: "",
      url_anonymous: "https://www.stonicks.com/embed/?c=4E6E82&sc=logaritmic&s=MSFT",
      ticker_url: "",
      url_stock: "",
      stocks: [],
      selected_ticker: '',
      search_text: "",
      is_a_search: false,
      modeOfStocks: '',
      myWidth: 0
  }),
  mounted() {
    this.myWidth = window.width;
    this._searchTitle()
    this._changeModeToStockMarket();
    var mode_waiting = setInterval(() => {
      if(this.modeOfStocks != ''){
        if(this._g_IsUserLogged){
          this.getStocks();
          clearInterval(mode_waiting); 
        }
      }
    }, 200);
    this.tickerChangerWatcher();

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  //////////////////////////////////////////////////////////////////////////////////////////////////
  watch:{
    filters: {
      hadler: function(){
        process.env.VUE_APP_API + '/stockchart?t=23&s=' + this._g_SelectedTicker.ticker;
      },
    deep: true
    },

    _g_SelectedTicker: {
      handler: function(){
        this._url_stock();
      }
    },

    _g_stocks: {
      handler: function(newVal, oldVal){
        this.stocks = newVal;
      },
      deep: true
    },

  },
  /////////////////////////////////////////////////////////////////////////////////////////////
  computed: {
    ...mapGetters(['_g_ToggleBetweenTableAndChart']),
    ...mapGetters({_g_stocks:'_g_Stocks'}),
    ...mapGetters(['_g_SelectedTicker', "_g_IsUserLogged", "_g_option_mobile", "_g_User", "_g_UserFeatures"]),
  },
  methods: {
    ...mapMutations(["setSelectedTicker", "setStocks"]),
      // _closeSearchTittle: function(){
      //   this.is_a_search = false;
      // },

      onResize() {
        this.isMobile = window.innerWidth < 901
        if(window.innerWidth < 901 && this.myWidth != window.width){
          window.location.reload()
        }
      },
      _getValueFromInput(value){
          this.ticker_url = value[0]
      },
      _searchStocks: function(){
        this.url_anonymous = "https://www.stonicks.com/embed/?c=4E6E82&sc=logaritmic&s=" + this.ticker_url
      },

      _closeSearch: function(){
        window.sessionStorage.removeItem('ticker_search_by_user');
        this.$router.push('/app/graficador-dinamico');
      },
      _searchTitle: function(){
        if(this.$route.params.param1 == undefined){
          this.is_a_search =  false;
        }else{
          this.is_a_search = true;
          let param_1 = this.$route.params.param1;
          let param_2 = this.$route.params.param2;
          const dictSubSearch = {
            'last_week': "última semana",
            'last_month': "último mes",
            'last_three_months': "últimos 3 meses",
            'last_year': "último año",
            'Energy': "Energía",
            'Materials': "Materiales",
            'Utilities': "Utilidades",
            'Financials': "Finanzas",
            'Consumer Staples': "Productos de 1ª necesidad",
            'Real State': "Inmobiliario",
            'Comunication Services': "Comunicación",
            'Industrials': "Industrial",
            'Consumer Discretionary': "Consumo discrecional",
            'Health Care': "Salud",
            'Information Technology': "Tecnologías de la información",
          };
          const dictSearches = {
            "last-ipos": "Últimas IPOs",
            "best-bullish-values": "Valores alcistas " + dictSubSearch[param_2],
            "hot-values": "Más comentados " + dictSubSearch[param_2],
            "exchange": "Índice " + param_2,
            "sector":"Sector " + dictSubSearch[param_2],
            "platinum": "Valores Platino",
            "favorites": param_2,
            "twin-souls": "Almas gemelas",
            "ticker": "Ticker " + param_2,
            "waitings": "Valores en espera",
            "open-positions": "Posiciones abiertas",
            "all-values": "Valores en la cartera",
            "best-sectors": "Mejores sectores " + dictSubSearch[param_2],
          };
          this.search_text = dictSearches[param_1];
        }
      },

      _changeModeToStockMarket: function(){
        let success = (response) => {this.modeOfStocks = response;};
        let url = "/api/v1/stock-finder/change-search-mode/stock-market";

        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('231', 'Error cambiando modo de búsqueda.');

        this._getAPICall(url, successHandler, failureHandler);

    },
  },
}
</script>


<style lang="scss">
.stockchart-chart {
    height: calc(89vh);
    position:relative;
    overflow:hidden;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
    background-color: var(--color-custom-stockchart-background);
}

@media screen and (max-height: 800px) {
  .stockchart-chart{
    margin-right: 21px;
  }
}

.stockchart{
    height: 100%;
    overflow:hidden;
}
#iframe {
    position: relative;
    z-index: 2;
}

#mobile-iframe{
  position: relative;
}

.title-searches{
    background-color: var(--color-custom-search-bar);
    text-align: center;
    height: 40px;
    margin-left: 82px !important;
    margin-right: 82px !important;
  }

  .close-searches{
    font-size: 16px;
    right: 30px;
    position: relative;
    margin-top: 10px;
    color: white;
    float: right;
  }

  .search-text{
    margin-top: 30px !important;
    line-height: 40px !important;
    color: white;
  }

  .chart-with-search-tittle{
    height: 94% !important;
  }

  #fullscreen-button-container-all-pages{
    display: none;
  }
</style>